// Utils
import getAbsoluteBoundingRect from '../../utils/getAbsoluteBoundingRect'

export default
{
    name: 'app-menu-mobile',

    data()
    {
        return {

        }
    },

    computed:
    {
        content()
        {
            return this.$root.contentPage.menu.acf
        },

        menuIsOpen()
        {
            return this.$root.menuIsOpen
        },

        menuMobileIsOpen()
        {
            return this.$root.menuMobileIsOpen
        }
    },

    created()
    {
        // Events
        this.eventHub.$on('keyboard:keydown', this._onKeydown)
        this.eventHub.$on('window:resize', this._onResize)
        this.eventHub.$on('mouse:move', this._onMousemove)
        this.eventHub.$on('window:raf', this._onEnterFrame)

        // Variables
        this._menuCloseTextOffsets =
        {
            x: 10,
            y: 10
        }

        this._mouse =
        {
            x: 0,
            y: 0,
            event:
            {
                x: 0,
                y: 0
            }
        }
        this._menuCloseRect = null
    },

    mounted()
    {
        this.$menuClose = this.$el.querySelector('.js-menu-close')
    },

    destroyed()
    {
        // Events
        this.eventHub.$off('keyboard:keydown', this._onKeydown)
        this.eventHub.$off('window:resize', this._onResize)
        this.eventHub.$off('mouse:move', this._onMousemove)
        this.eventHub.$off('window:raf', this._onEnterFrame)
    },

    methods:
    {
        // Events
        _onKeydown(event)
        {
            if (this.menuMobileIsOpen
                && event.keyCode === 27)
            {
                this._closeMenuMobile()
            }
        },

        _onResize()
        {
            if (this.$menuClose)
            {
                this._menuCloseRect = getAbsoluteBoundingRect(this.$menuClose)
            }
        },

        _onMousemove(mouse)
        {
            this._mouse.event.x = mouse.x + this._menuCloseTextOffsets.x
            this._mouse.event.y = mouse.y + this._menuCloseTextOffsets.y
        },

        _onEnterFrame()
        {
            this._mouse.x += (this._mouse.event.x - this._mouse.x) * 0.1
            this._mouse.x = Math.round(this._mouse.x * 100) / 100

            this._mouse.y += (this._mouse.event.y - this._mouse.y) * 0.1
            this._mouse.y = Math.round(this._mouse.y * 100) / 100

            if (this.$menuClose
                && !this.menuIsOpen
                && this.menuMobileIsOpen)
            {
                const translateX = Math.min(this._mouse.x, this.$root.width - this._menuCloseRect.width)
                const translateY = Math.min(this._mouse.y, this.$root.height - this._menuCloseRect.height)

                this.$menuClose.style.transform = `translateX(${translateX}px) translateY(${translateY}px) translateZ(0)`
            }
        },

        // HTML Actions
        _onClickOnOverlay()
        {
            this._closeMenuMobile()
        },

        // HTML Actions
        _clickOnRestaurants()
        {
            const action = this.menuIsOpen ? 'close' : 'open'
            this.eventHub.$emit(`menu:${action}`)
        },

        // Actions
        _closeMenuMobile()
        {
            this.eventHub.$emit('menu-mobile:close')
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-menu-mobile/script.js